class FreeGiftProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progressTextTemplate = this.dataset.progressText ;
    this.successTextTemplate = this.dataset.successText ;
    this.giftName = this.dataset.giftName || '';
  }

  connectedCallback() {
    this.render();
  }

  static get observedAttributes() {
    return ['data-cart-total', 'data-threshold', 'data-remaining', 'data-progress'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.render();
    }
  }

  render() {
    const cartTotal = parseInt(this.dataset.cartTotal || 0, 10) || 0;
    const threshold = parseInt(this.dataset.threshold || 0, 10) || 0;
    const remaining = parseInt(this.dataset.remaining || 0, 10) || 0;
    const storedProgress = parseFloat(this.dataset.progress || 0);
    const computedProgress = threshold > 0 ? (cartTotal / threshold) * 100 : 0;
    const progressValue = Math.min(100, Math.max(0, Number.isFinite(computedProgress) ? computedProgress : storedProgress || 0));
    const isEarned = this.dataset.earned === 'true' || progressValue >= 100;
    const amountText = this.formatMoney(remaining);

    const pendingText = this.progressTextTemplate
      .replace('{amount}', amountText)
      .replace('[amount]', amountText)
      .replace('{gift_name}', this.giftName)
      .replace('[gift_name]', this.giftName);

    const successText = this.successTextTemplate
      .replace('{gift_name}', this.giftName)
      .replace('[gift_name]', this.giftName);

    const displayText = isEarned ? successText : pendingText;
    const fillPercent = isEarned ? 100 : progressValue;

    const existingFill = this.querySelector('.free-gift-progress-bar__fill');
    
    if (existingFill) {
      existingFill.style.width = `${fillPercent}%`;
      const textContent = this.querySelector('.free-gift-progress-bar__text-content');
      if (textContent) {
        textContent.textContent = displayText;
      }
    } else {
      this.innerHTML = `
        <div class="free-gift-progress-bar__content">
          <p class="free-gift-progress-bar__text">
            <span class="free-gift-progress-bar__emoji">👍</span>
            <span class="free-gift-progress-bar__text-content">${displayText}</span>
          </p>
          <div class="free-gift-progress-bar__track">
            <div class="free-gift-progress-bar__fill" style="width: ${fillPercent}%"></div>
          </div>
          <p class="free-gift-progress-bar__gift-name">${this.giftName}</p>
        </div>
      `;
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(cents / 100);
  }
}

customElements.define('free-gift-progress-bar', FreeGiftProgressBar);
